import { useContext } from 'react'
import { useFormik } from 'formik'
import { useNavigate, useLocation } from 'react-router-dom'
import { useRestPasswordService } from 'services/useAuthService'
import * as Yup from 'yup'
import { ToastContext } from 'contexts'

const validationSchema = Yup.object().shape({
    password: Yup.string()
        .required('Please enter your password.')
        .matches(
            /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
            'Password must contain at least 8 characters, one uppercase, one number and one special case character.',
        ),
    confirm_password: Yup.string()
        .required('Please confirm your password')
        .oneOf([Yup.ref('password'), null], "Passwords don't match."),
})

const initialValues = {
    password: '',
    confirm_password: '',
}

const useResetPassword = () => {
    const { setToast } = useContext(ToastContext)
    const navigate = useNavigate()

    const { ...args }: any = useLocation()
    const token = args.search.split('token=')[1]

    const { resetPassword, loading: resetPasswordLoading } = useRestPasswordService()

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema,
        onSubmit: async values => {
            const response = await resetPassword(values.password, values.confirm_password, token)

            if (response.hasError && response?.error?.networkError?.result?.statusCode === 400) {
                return setToast({
                    message: 'Incorrect confirm password',
                    type: 'negative',
                    open: true,
                })
            }

            if (response && response.success) {
                setToast({
                    message: 'Password successfully updated',
                    type: 'positive',
                    open: true,
                })
                setTimeout(() => {
                    navigate('/login')
                }, 1500)
            }
        },
    })

    return {
        formik,
        resetPasswordLoading,
    }
}

export default useResetPassword
